import React from 'react';
import { components } from 'react-select';
import styled from 'styled-components';
import { FONT_SIZES, LINE_HEIGHT_SIZES } from '../../../utils/constants';
import { alto, boulder, java, white } from '@parchment/atoms';
const StyledHeading = /*#__PURE__*/styled.div.withConfig({
  displayName: "MenuList__StyledHeading",
  componentId: "sc-13ayumc-0"
})(["padding:5px 10px 5px 10px;font-size:", ";line-height:", ";color:", ";&:hover{cursor:pointer;background-color:", ";color:", ";}"], props => FONT_SIZES[props.scale], props => LINE_HEIGHT_SIZES[props.scale], boulder, java, white);
StyledHeading.displayName = 'StyledHeading';
const MenuHeadingContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "MenuList__MenuHeadingContainer",
  componentId: "sc-13ayumc-1"
})(["padding:8px 0 8px 0;box-shadow:inset 0 -1px 0 0 ", ";"], alto);
MenuHeadingContainer.displayName = 'MenuHeadingContainer';
export class MenuList extends React.Component {
  static get propTypes() {
    return {
      ...components.MenuList.propTypes
    };
  }
  static get defaultProps() {
    return {
      ...components.MenuList.defaultProps
    };
  }
  renderHeading() {
    if (!this.props.selectProps.disableDeselect) {
      return /*#__PURE__*/React.createElement(MenuHeadingContainer, null, /*#__PURE__*/React.createElement(StyledHeading, {
        onClick: this.props.clearValue
      }, this.props.selectProps.deselectText));
    }
  }
  render() {
    return /*#__PURE__*/React.createElement(components.MenuList, this.props, this.renderHeading(), this.props.children);
  }
}